import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/ContestSign.svg'

export const IconContestSign = IconSVG as IconComponent
